import { useEffect } from 'react';

const GUARD_KEY = '__lctfViewerGuard';

type GuardState = { [GUARD_KEY]?: boolean };

/**
 * While a PDF/2D viewer overlay is open, block horizontal overscroll / trackpad
 * swipe-back from navigating browser history (which unmounts the viewer).
 */
export function usePreventViewerHistoryBack(enabled = true): void {
  useEffect(() => {
    if (!enabled || typeof window === 'undefined') return;

    const html = document.documentElement;
    const body = document.body;
    const prevHtml = html.style.overscrollBehaviorX;
    const prevBody = body.style.overscrollBehaviorX;
    html.style.overscrollBehaviorX = 'none';
    body.style.overscrollBehaviorX = 'none';

    const token: GuardState = { [GUARD_KEY]: true };
    window.history.pushState(token, '');
    let closing = false;

    const onPopState = () => {
      if (closing) return;
      // Re-push so Back / edge-swipe does not leave the page or dismiss the viewer.
      window.history.pushState(token, '');
    };
    window.addEventListener('popstate', onPopState);

    return () => {
      closing = true;
      window.removeEventListener('popstate', onPopState);
      html.style.overscrollBehaviorX = prevHtml;
      body.style.overscrollBehaviorX = prevBody;
      const state = window.history.state as GuardState | null;
      if (state?.[GUARD_KEY]) {
        window.history.back();
      }
    };
  }, [enabled]);
}
